import {
  fetchGeoFenceAreas,
  fetchGeoFenceTypes,
  addNewAttendanceGeoFenceArea,
  removeAttendanceGeoFenceArea,
  updateAttendanceGeoFenceArea,
  removeHoliday,
  addNewHoliday,
  fetchWorkStation,
  addNewWorkStation,
  editWorkStation,
  removeWorkstation,
  editGlobalSetting,
  fetchChangeDeviceMailSettings,
  addChangeDeviceMailSettings,
  removeChangeDeviceMailSetting,
  fetchChangeDeviceSetting,
  updateChangeDeviceSetting,
  fetchTimesheetApprovers,
  postTimesheetApprovers,
  removeTimesheetApprover,
  getDefaultTimeSheetApprover,
  getDefaultTimeSheetReviewers,
  getTimeSheetApproverSetting,
  updateTimeSheetSettings,
  deleteDefaultTimeSheetApprover,
  deleteTimeSheetReviewer,
  addDefaultTimesheetApprovers,
  addTimesheetReviewers,
  getTimeSheetTeamMember,
  deleteTimeSheetMember,
  addTeamMembers,
  getTimeSheetMember,
  addBulkTimesheetApprover
} from "@/services/api/attendanceSetting";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getUserGlobalSetting } from "./teamSlice";
import { handleResponse } from "@/services/axios";

export interface LoadingState {
  geoFenceAreas: boolean;
  geoFenceTypes: boolean;
  addGeoFence: boolean;
  updateGeoFence: boolean;
  removeGeoFence: boolean;
  holidays: boolean;
  addHoliday: boolean;
  deleteHoliday: boolean;
  workStation: boolean;
  addWorkStation: boolean;
  updateWorkStation: boolean;
  deleteWorkstation: boolean;
  globalSetting: boolean;
  updateGlobalSetting: boolean;
  deviceSetting: boolean;
  updateDeviceSetting: boolean;
  deviceMailSettings: boolean;
  addDeviceMailSettings: boolean;
  removeDeviceMailSetting: boolean;
  logsChangeSetting: boolean;
}

export interface IAttendanceState {
  geoFenceAreas: any[];
  geoFenceTypes: any[];
  userGlobalSetting: any | null;
  workStationList: any[];
  deviceSetting: any | null;
  deviceMailSettings: any[];
  loading: LoadingState;
  timesheetApproversTableData: any | null;
  timeSheetApproverSettings: any | null;
  defaultTimeSheetApprover: any[];
  TimeSheetReviewers: any[];
  teamMember : any[];
  timeSheetMember : any[];
  isFetchingTimesheetApprovers: boolean;
  error: string | null;
  loadingFlag:boolean;
}

const initialState: IAttendanceState = {
  geoFenceAreas: [],
  geoFenceTypes: [],
  userGlobalSetting: null,
  workStationList: [],
  deviceSetting: null,
  deviceMailSettings: [],
  timesheetApproversTableData: null,
  timeSheetApproverSettings: null,
  defaultTimeSheetApprover: [],
  TimeSheetReviewers: [],
  teamMember: [],
  timeSheetMember: [],
  isFetchingTimesheetApprovers: false,
  loadingFlag:false,
  loading: {
    geoFenceAreas: false,
    geoFenceTypes: false,
    addGeoFence: false,
    updateGeoFence: false,
    removeGeoFence: false,
    holidays: false,
    addHoliday: false,
    deleteHoliday: false,
    workStation: false,
    addWorkStation: false,
    updateWorkStation: false,
    deleteWorkstation: false,
    globalSetting: false,
    updateGlobalSetting: false,
    deviceSetting: false,
    updateDeviceSetting: false,
    deviceMailSettings: false,
    addDeviceMailSettings: false,
    removeDeviceMailSetting: false,
    logsChangeSetting: false,
  },
  error: null,
};

export const getGeoFenceAreas = createAsyncThunk(
  "attendance/getGeoFenceAreas",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchGeoFenceAreas();
      const result = handleResponse(response, rejectWithValue);
      return result;
    } catch (error: any) {
      return rejectWithValue(
        error?.Message ?? "Failed to fetch geo fence areas data",
      );
    }
  },
);

export const removeGeoFenceArea = createAsyncThunk(
  "attendance/removeGeoFenceArea",
  async (id: number, { rejectWithValue, dispatch }) => {
    try {
      const response = await removeAttendanceGeoFenceArea(id);
      await dispatch(getGeoFenceAreas()).unwrap();
      return handleResponse(response, rejectWithValue);
    } catch (error: any) {
      return rejectWithValue(
        error?.Message ?? "Failed to remove geo fence area",
      );
    }
  },
);

export const addNewGeoFenceArea = createAsyncThunk(
  "attendance/addNewGeoFenceArea",
  async (payload: any, { rejectWithValue, dispatch }) => {
    try {
      const res = await addNewAttendanceGeoFenceArea(payload);
      const result = handleResponse(res, rejectWithValue);
      await dispatch(getGeoFenceAreas()).unwrap();
      return result;
    } catch (err: any) {
      return rejectWithValue(err?.Message);
    }
  },
);

export const updateGeoFenceArea = createAsyncThunk(
  "attendance/updateGeoFenceArea",
  async (payload: any, { rejectWithValue, dispatch }) => {
    try {
      const res = await updateAttendanceGeoFenceArea(payload);
      const result = handleResponse(res, rejectWithValue);
      await dispatch(getGeoFenceAreas()).unwrap();
      return result;
    } catch (err: any) {
      return rejectWithValue(err?.Message);
    }
  },
);

export const getGeoFenceTypes = createAsyncThunk(
  "attendance/getGeoFenceTypes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchGeoFenceTypes();
      const result = handleResponse(response, rejectWithValue);
      return result;
    } catch (error: any) {
      return rejectWithValue(
        error?.Message ?? "Failed to fetch geo fence types data",
      );
    }
  },
);

export const deleteHoliday = createAsyncThunk(
  "attendance/removeHoliday",
  async (id: number, { rejectWithValue, dispatch }) => {
    try {
      const response = await removeHoliday(id);
      await dispatch(getUserGlobalSetting()).unwrap();
      return handleResponse(response, rejectWithValue);
    } catch (error: any) {
      return rejectWithValue(error?.Message ?? "Failed to remove holiday");
    }
  },
);

export const addHoliday = createAsyncThunk(
  "attendance/addHoliday",
  async (payload: any, { rejectWithValue, dispatch }) => {
    try {
      const res = await addNewHoliday(payload);
      const result = handleResponse(res, rejectWithValue);
      await dispatch(getUserGlobalSetting()).unwrap();
      return result;
    } catch (err: any) {
      return rejectWithValue(err?.Message);
    }
  },
);

export const getWorkStation = createAsyncThunk(
  "attendance/WorkStation",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchWorkStation();
      const result = handleResponse(response, rejectWithValue);
      return result.Items;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const addWorkStation = createAsyncThunk(
  "attendance/addWorkStation",
  async (payload: any, { rejectWithValue, dispatch }) => {
    try {
      const res = await addNewWorkStation(payload);
      const result = handleResponse(res, rejectWithValue);
      await dispatch(getWorkStation()).unwrap();
      return result;
    } catch (err: any) {
      return rejectWithValue(err?.Message);
    }
  },
);

export const updateWorkStation = createAsyncThunk<
  any,
  { Id: number; Name: string }
>(
  "attendance/updateWorkStation",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const res = await editWorkStation(payload.Id, { Name: payload.Name });
      const result = handleResponse(res, rejectWithValue);
      await dispatch(getWorkStation()).unwrap();
      return result;
    } catch (err: any) {
      return rejectWithValue(err?.Message);
    }
  },
);

export const deleteWorkstation = createAsyncThunk(
  "attendance/deleteWorkstation",
  async (id: number, { rejectWithValue, dispatch }) => {
    try {
      const response = await removeWorkstation(id);
      await dispatch(getWorkStation()).unwrap();
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.Message || "Failed to delete workstation");
    }
  },
);

export const updateGlobalSetting = createAsyncThunk(
  "attendance/updateGlobalSetting",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await editGlobalSetting(data);
      await dispatch(getUserGlobalSetting()).unwrap();
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.Message || "Failed to update global setting");
    }
  },
);

export const getDeviceSetting = createAsyncThunk(
  "attendance/getDeviceSetting",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchChangeDeviceSetting();
      return handleResponse(response, rejectWithValue);
    } catch (error: any) {
      return rejectWithValue(error?.Message || "Failed to fetch device setting");
    }
  },
);

export const updateDeviceSetting = createAsyncThunk(
  "attendance/updateDeviceSetting",
  async (payload: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await updateChangeDeviceSetting(payload);
      const result = handleResponse(response, rejectWithValue);
      dispatch(getDeviceSetting());
      return result;
    } catch (error: any) {
      return rejectWithValue(error?.Message || "Failed to update device setting");
    }
  },
);

export const getDeviceMailSettings = createAsyncThunk(
  "attendance/getDeviceMailSettings",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchChangeDeviceMailSettings();
      return handleResponse(response, rejectWithValue);
    } catch (error: any) {
      return rejectWithValue(error?.Message || "Failed to fetch device mail settings");
    }
  },
);

export const addDeviceMailSettings = createAsyncThunk(
  "attendance/addDeviceMailSettings",
  async (payload: string, { rejectWithValue, dispatch }) => {
    try {
      const response = await addChangeDeviceMailSettings(payload);
      const result = handleResponse(response, rejectWithValue);
      dispatch(getDeviceMailSettings());
      return result;
    } catch (error: any) {
      return rejectWithValue(error?.Message || "Failed to add device mail settings");
    }
  },
);

export const removeDeviceMailSetting = createAsyncThunk(
  "attendance/removeDeviceMailSetting",
  async (id: number, { rejectWithValue, dispatch }) => {
    try {
      const response = await removeChangeDeviceMailSetting(id);
      const result = handleResponse(response, rejectWithValue);
      dispatch(getDeviceMailSettings());
      return result;
    } catch (error: any) {
      return rejectWithValue(error?.Message || "Failed to remove device mail setting");
    }
  },
);

export const getTimesheetApprovers = createAsyncThunk(
  "attendance/getTimesheetApprovers",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await fetchTimesheetApprovers(params);
      const result = handleResponse(response, rejectWithValue);
      return result;
    } catch (error: any) {
      return rejectWithValue(
        error?.Message || "Failed to fetch timesheet approvers"
      );
    }
  }
);

export const setTimesheetApprovers = createAsyncThunk(
  "attendance/setTimesheetApprovers",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await postTimesheetApprovers(payload);
      const result = handleResponse(response, rejectWithValue);
      return result;
    } catch (error: any) {
      return rejectWithValue(
        error?.Message || "Failed to set timesheet approvers"
      );
    }
  }
);

export const deleteTimesheetApprover = createAsyncThunk(
  "attendance/deleteTimesheetApprover",
  async (payload: { leaveUserId: number; approverId: number; approvalOrder: number }, { rejectWithValue }) => {
    try {
      const response = await removeTimesheetApprover(payload);
      const result = handleResponse(response, rejectWithValue);
      return result;
    } catch (error: any) {
      return rejectWithValue(
        error?.Message || "Failed to delete timesheet approver"
      );
    }
  }
);

export const DefaultTimesheetApprovers = createAsyncThunk(
  "attendance/DefaultTimesheetApprovers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getDefaultTimeSheetApprover();
      return handleResponse(response, rejectWithValue);
    } catch (error: any) {
      return rejectWithValue(
        error?.Message || "Failed to fetch default timesheet approvers"
      );
    }
  }
);

export const TimesheetReviewers = createAsyncThunk(
  "attendance/TimesheetReviewers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getDefaultTimeSheetReviewers();
      return handleResponse(response, rejectWithValue);
    } catch (error: any) {
      return rejectWithValue(
        error?.Message || "Failed to fetch default timesheet approvers"
      );
    }
  }
);

export const getTimeSheetApproverSettings = createAsyncThunk(
  "attendance/getTimeSheetApproverSettings",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getTimeSheetApproverSetting();
      return handleResponse(response, rejectWithValue);
    } catch (error: any) {
      return rejectWithValue(
        error?.Message || "Failed to fetch timesheet approver settings"
      );
    }
  }
);

export const setTimeSheetSettings = createAsyncThunk(
  "attendance/setTimeSheetSettings",
  async (payload: any, { rejectWithValue,dispatch }) => {
    try {
      const res = await updateTimeSheetSettings(payload);
      dispatch(getTimeSheetApproverSettings());
      return handleResponse(res, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data?.Message || "Failed to update leave settings");
    }
  }
);

export const deletedefaultTimeSheetApprover = createAsyncThunk(
  "attendance/deleteDefaultTimeSheetApprover",
  async (id: number, { rejectWithValue, dispatch }) => {
    try {
      const res = await deleteDefaultTimeSheetApprover(id);
      dispatch(DefaultTimesheetApprovers());
      return handleResponse(res, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data?.Message || "Failed to delete default approver");
    }
  }
);

export const deletetimeSheetReviewer = createAsyncThunk(
  "attendance/deleteDefaultTimeSheetApprover",
  async (id: number, { rejectWithValue, dispatch }) => {
    try {
      const res = await deleteTimeSheetReviewer(id);
      dispatch(TimesheetReviewers());
      return handleResponse(res, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data?.Message || "Failed to delete default approver");
    }
  }
);

export const addDefaultTimeSheetApprovers = createAsyncThunk(
  "attendance/addDefaultTimeSheetApprovers",
  async (payload: { UserId: number }[], { rejectWithValue, dispatch }) => {
    try {
      const res = await addDefaultTimesheetApprovers(payload);
      dispatch(DefaultTimesheetApprovers());
      return handleResponse(res, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data?.Message || "Failed to add default approvers");
    }
  }
);

export const addTimeSheetReviewers = createAsyncThunk(
  "attendance/addTimeSheetReviewers",
  async (payload: { UserId: number }[], { rejectWithValue, dispatch }) => {
    try {
      const res = await addTimesheetReviewers(payload);
      dispatch(TimesheetReviewers());
      return handleResponse(res, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data?.Message || "Failed to add default approvers");
    }
  }
);

export const getTimesheetNotifyTeamMember = createAsyncThunk(
  "attendance/getTimesheetNotifyTeamMember",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getTimeSheetTeamMember();
      return handleResponse(response, rejectWithValue);
    } catch (error: any) {
      return rejectWithValue(
        error?.Message || "Failed to fetch timesheet approvers"
      );
    }
  }
);

export const deletetimeSheetNotifyTeamMember = createAsyncThunk(
  "attendance/deletetimeSheetTeamMember",
  async (id: number, { rejectWithValue, dispatch }) => {
    try {
      const res = await deleteTimeSheetMember(id);
      dispatch(getTimesheetNotifyTeamMember());
      return handleResponse(res, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data?.Message || "Failed to delete default approver");
    }
  }
);

export const addTeamMember = createAsyncThunk(
  "attendance/addTeamMember",
  async (userIds: string, { rejectWithValue, dispatch }) => {
    try {
      const res = await addTeamMembers(userIds);
      dispatch(getTimesheetNotifyTeamMember());
      return handleResponse(res, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data?.Message || "Failed to add leave users");
    }
  }
);

export const getTimesheetTeamMember = createAsyncThunk(
  "attendance/getTimesheetTeamMember",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getTimeSheetMember();
      return handleResponse(response, rejectWithValue);
    } catch (error: any) {
      return rejectWithValue(
        error?.Message || "Failed to fetch timesheet approvers"
      );
    }
  }
);

export const addBulkTimesheetApprovers = createAsyncThunk(
  "attendance/addBulkTimesheetApprovers",
  async (payload: any, { rejectWithValue, dispatch }) => {
    try {
      const res = await addBulkTimesheetApprover(payload);    
      return handleResponse(res, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data?.Message || "Failed to add bulk timesheet approvers");
    }
  }
);

const attendanceSettingSlice = createSlice({
  name: "attendanceSetting",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // GeoFence Areas
      .addCase(getGeoFenceAreas.pending, (state) => {
        state.loading.geoFenceAreas = true;
        state.error = null;
      })
      .addCase(getGeoFenceAreas.fulfilled, (state, action) => {
        state.loading.geoFenceAreas = false;
        state.geoFenceAreas = action.payload as any[];
      })
      .addCase(getGeoFenceAreas.rejected, (state, action) => {
        state.loading.geoFenceAreas = false;
        state.error = (action.payload as string) ?? "Unknown error occurred";
      })
      .addCase(addNewGeoFenceArea.pending, (state) => {
        state.loading.addGeoFence = true;
      })
      .addCase(addNewGeoFenceArea.fulfilled, (state) => {
        state.loading.addGeoFence = false;
      })
      .addCase(addNewGeoFenceArea.rejected, (state, action) => {
        state.loading.addGeoFence = false;
        state.error = action.payload as string;
      })
      .addCase(updateGeoFenceArea.pending, (state) => {
        state.loading.updateGeoFence = true;
      })
      .addCase(updateGeoFenceArea.fulfilled, (state) => {
        state.loading.updateGeoFence = false;
      })
      .addCase(updateGeoFenceArea.rejected, (state, action) => {
        state.loading.updateGeoFence = false;
        state.error = action.payload as string;
      })
      .addCase(removeGeoFenceArea.pending, (state) => {
        state.loading.removeGeoFence = true;
      })
      .addCase(removeGeoFenceArea.fulfilled, (state) => {
        state.loading.removeGeoFence = false;
      })
      .addCase(removeGeoFenceArea.rejected, (state, action) => {
        state.loading.removeGeoFence = false;
        state.error = action.payload as string;
      })

      // GeoFence Types
      .addCase(getGeoFenceTypes.pending, (state) => {
        state.loading.geoFenceTypes = true;
        state.error = null;
      })
      .addCase(getGeoFenceTypes.fulfilled, (state, action) => {
        state.loading.geoFenceTypes = false;
        state.geoFenceTypes = action.payload;
      })
      .addCase(getGeoFenceTypes.rejected, (state, action) => {
        state.loading.geoFenceTypes = false;
        state.error = (action.payload as string) ?? "Unknown error occurred";
      })

      // Global Setting
      .addCase(getUserGlobalSetting.pending, (state) => {
        state.loading.globalSetting = true;
      })
      .addCase(getUserGlobalSetting.fulfilled, (state, action) => {
        state.loading.globalSetting = false;
        state.userGlobalSetting = action.payload;
      })
      .addCase(getUserGlobalSetting.rejected, (state, action) => {
        state.loading.globalSetting = false;
        state.error = action.payload as string;
      })
      .addCase(updateGlobalSetting.pending, (state) => {
        state.loading.updateGlobalSetting = true;
      })
      .addCase(updateGlobalSetting.fulfilled, (state) => {
        state.loading.updateGlobalSetting = false;
      })
      .addCase(updateGlobalSetting.rejected, (state, action) => {
        state.loading.updateGlobalSetting = false;
        state.error = action.payload as string;
      })

      // Holidays
      .addCase(addHoliday.pending, (state) => {
        state.loading.addHoliday = true;
      })
      .addCase(addHoliday.fulfilled, (state) => {
        state.loading.addHoliday = false;
      })
      .addCase(addHoliday.rejected, (state, action) => {
        state.loading.addHoliday = false;
        state.error = action.payload as string;
      })
      .addCase(deleteHoliday.pending, (state) => {
        state.loading.deleteHoliday = true;
      })
      .addCase(deleteHoliday.fulfilled, (state) => {
        state.loading.deleteHoliday = false;
      })
      .addCase(deleteHoliday.rejected, (state, action) => {
        state.loading.deleteHoliday = false;
        state.error = action.payload as string;
      })

      // WorkStation
      .addCase(getWorkStation.pending, (state) => {
        state.loading.workStation = true;
      })
      .addCase(getWorkStation.fulfilled, (state, action) => {
        state.loading.workStation = false;
        state.workStationList = action.payload;
      })
      .addCase(getWorkStation.rejected, (state, action) => {
        state.loading.workStation = false;
        state.error = action.payload as string;
      })
      .addCase(addWorkStation.pending, (state) => {
        state.loading.addWorkStation = true;
      })
      .addCase(addWorkStation.fulfilled, (state) => {
        state.loading.addWorkStation = false;
      })
      .addCase(addWorkStation.rejected, (state, action) => {
        state.loading.addWorkStation = false;
        state.error = action.payload as string;
      })
      .addCase(updateWorkStation.pending, (state) => {
        state.loading.updateWorkStation = true;
      })
      .addCase(updateWorkStation.fulfilled, (state) => {
        state.loading.updateWorkStation = false;
      })
      .addCase(updateWorkStation.rejected, (state, action) => {
        state.loading.updateWorkStation = false;
        state.error = action.payload as string;
      })
      .addCase(deleteWorkstation.pending, (state) => {
        state.loading.deleteWorkstation = true;
      })
      .addCase(deleteWorkstation.fulfilled, (state) => {
        state.loading.deleteWorkstation = false;
      })
      .addCase(deleteWorkstation.rejected, (state, action) => {
        state.loading.deleteWorkstation = false;
        state.error = action.payload as string;
      })

      // Device Setting
      .addCase(getDeviceSetting.pending, (state) => {
        state.loading.deviceSetting = true;
      })
      .addCase(getDeviceSetting.fulfilled, (state, action) => {
        state.loading.deviceSetting = false;
        state.deviceSetting = action.payload;
      })
      .addCase(getDeviceSetting.rejected, (state, action) => {
        state.loading.deviceSetting = false;
        state.error = (action.payload as string) || "Failed to fetch device setting";
      })
      .addCase(updateDeviceSetting.pending, (state) => {
        state.loading.updateDeviceSetting = true;
      })
      .addCase(updateDeviceSetting.fulfilled, (state, action) => {
        state.loading.updateDeviceSetting = false;
        state.deviceSetting = action.payload;
      })
      .addCase(updateDeviceSetting.rejected, (state, action) => {
        state.loading.updateDeviceSetting = false;
        state.error = (action.payload as string) || "Failed to update device setting";
      })

      // Device Mail Settings
      .addCase(getDeviceMailSettings.pending, (state) => {
        state.loading.deviceMailSettings = true;
      })
      .addCase(getDeviceMailSettings.fulfilled, (state, action) => {
        state.loading.deviceMailSettings = false;
        state.deviceMailSettings = action.payload || [];
      })
      .addCase(getDeviceMailSettings.rejected, (state, action) => {
        state.loading.deviceMailSettings = false;
        state.error = (action.payload as string) || "Failed to fetch device mail settings";
      })
      .addCase(addDeviceMailSettings.pending, (state) => {
        state.loading.addDeviceMailSettings = true;
      })
      .addCase(addDeviceMailSettings.fulfilled, (state) => {
        state.loading.addDeviceMailSettings = false;
      })
      .addCase(addDeviceMailSettings.rejected, (state, action) => {
        state.loading.addDeviceMailSettings = false;
        state.error = (action.payload as string) || "Failed to add device mail settings";
      })
      .addCase(removeDeviceMailSetting.pending, (state) => {
        state.loading.removeDeviceMailSetting = true;
        state.loading.logsChangeSetting = true;
      })
      .addCase(removeDeviceMailSetting.fulfilled, (state) => {
        state.loading.removeDeviceMailSetting = false;
        state.loading.logsChangeSetting = false;
      })
      .addCase(removeDeviceMailSetting.rejected, (state, action) => {
        state.loading.removeDeviceMailSetting = false;
        state.loading.logsChangeSetting = false;
        state.error = (action.payload as string) || "Failed to remove device mail setting";
      })
      .addCase(getTimesheetApprovers.pending, (state) => {
        state.isFetchingTimesheetApprovers = true;
        state.error = null;
      })
      .addCase(getTimesheetApprovers.fulfilled, (state, action) => {
        state.isFetchingTimesheetApprovers = false;
        state.timesheetApproversTableData = action.payload;
      })
      .addCase(getTimesheetApprovers.rejected, (state, action) => {
        state.isFetchingTimesheetApprovers = false;
        state.error = (action.payload as string) || "Failed to fetch timesheet approvers";
      })
      .addCase(DefaultTimesheetApprovers.pending, (state) => {
        state.loadingFlag = true;
      })
      .addCase(DefaultTimesheetApprovers.fulfilled, (state, action) => {
        state.loadingFlag = false;
        state.defaultTimeSheetApprover = action.payload || [];
      })
      .addCase(DefaultTimesheetApprovers.rejected, (state, action) => {
        state.loadingFlag = false;
        state.error = (action.payload as string) || "Failed to fetch default timesheet approver";
      })
      .addCase(TimesheetReviewers.pending, (state) => {
        state.loadingFlag = true;
      })
      .addCase(TimesheetReviewers.fulfilled, (state, action) => {
        state.loadingFlag = false;
        state.TimeSheetReviewers = action.payload || [];
      })
      .addCase(TimesheetReviewers.rejected, (state, action) => {
        state.loadingFlag = false;
        state.error = (action.payload as string) || "Failed to fetch timesheet reviewers";
      })
      .addCase(getTimeSheetApproverSettings.pending, (state) => {
        state.loadingFlag = true;
      })
      .addCase(getTimeSheetApproverSettings.fulfilled, (state, action) => {
        state.loadingFlag = false;
        state.timeSheetApproverSettings = action.payload;
      })
      .addCase(getTimeSheetApproverSettings.rejected, (state, action) => {
        state.loadingFlag = false;
        state.timeSheetApproverSettings = null;
        state.error = (action.payload as string) || "Failed to fetch timesheet approver settings";
      })
      .addCase(getTimesheetNotifyTeamMember.pending, (state) => {
        state.loadingFlag = true;
      })
      .addCase(getTimesheetNotifyTeamMember.fulfilled, (state, action) => {
        state.loadingFlag = false;
        state.teamMember = action.payload;
      })
      .addCase(getTimesheetNotifyTeamMember.rejected, (state, action) => {
        state.loadingFlag = false;
        state.error = (action.payload as string) || "Failed to fetch team Member";
      })
      .addCase(getTimesheetTeamMember.pending, (state) => {
        state.loadingFlag = true;
      })
      .addCase(getTimesheetTeamMember.fulfilled, (state, action) => {
        state.loadingFlag = false;
        state.timeSheetMember = action.payload;
      })
      .addCase(getTimesheetTeamMember.rejected, (state, action) => {
        state.loadingFlag = false;
        state.error = (action.payload as string) || "Failed to fetch team Member";
      })
  },
});

export const { } = attendanceSettingSlice.actions;
export default attendanceSettingSlice.reducer;
